<template>
    <div class="question-block pa-4 mt-4">
        <div class="headline mb-4 font-weight-bold">{{ $t("Вопрос {questionNumber} из {questionsCount}", {questionNumber: question_number+1, questionsCount: questions_length}) }}</div>
        <div class="question-text mb-4" v-html="questions[question_number].question"></div>
        <v-layout column mb-5>
            <QuestionTypeSwitch
                :name="questions[question_number].type"
                :question_type='questions[question_number].type'
                :variants="questions[question_number].type !='text_field' ? questions[question_number].variants : []"
            />
        </v-layout>
        <v-layout wrap row justify-space-between>
            <buttonBdWhite :class="{'flex xs12 order-xs2 mb-4': $vuetify.breakpoint.xs}" @click.native="prev_question()" v-text="question_number > 0 ? $t('Предыдущий вопрос') : $t('Назад к урокам')" />
            <buttonRed v-if="question_number<questions_length-1" :class="{'flex xs12 mb-2': $vuetify.breakpoint.xs}" @click.native="NEXT_QUESTION()">{{ $t("Следующий вопрос") }}</buttonRed>
            <buttonRed v-if="test_attempts > 0 && question_number==questions_length-1 && points_earned_test<points_required_test" :class="{'flex xs12 mb-2': $vuetify.breakpoint.xs}" @click.native="$router.push({name: 'study'})">{{ $t("Готово") }}</buttonRed>
            <buttonRed v-if="question_number==questions_length-1 && (points_earned_test>=points_required_test || test_attempts == 0)" :class="{'flex xs12 mb-2': $vuetify.breakpoint.xs}" @click.native="$router.push({name: 'study'})">{{ $t("Готово") }}</buttonRed>
        </v-layout>
    </div>
</template>

<script>
import {button_red, button_bd_white} from '@/components/ui/buttons/base_buttons.js';
import QuestionTypeSwitch from './question_type_switch';
import {mapGetters, mapMutations, mapActions} from 'vuex';

export default {
  components: {
    QuestionTypeSwitch,
    'buttonRed'    : button_red,
    'buttonBdWhite': button_bd_white,
  },
  computed: {
    ...mapGetters('testing/questions', [
      'question_number',
      'questions',
      'stats',
      'questions_length',
      'question_answered',
    ]),
    ...mapGetters('course_info', [
      'points_earned_test',
      'points_required_test',
      'test_attempts',
    ]),
  },
  methods: {
    ...mapMutations('testing/questions', [
      'NEXT_QUESTION',
      'PREV_QUESTION',
    ]),
    ...mapActions('testing/questions', [
      'prev_question',
      'next_question',
      'test_result',
    ]),
    ...mapActions('testing', [
      'start_test',
      'test_cancel',
    ]),
    question_type: function(question) {
      if (question.type=='radio') {
        return 'radio';
      } else {
        return 'checkbox';
      }
    },
  },
};
</script>
